// extracted by mini-css-extract-plugin
export default {"modalOverlay":"_B-z","modalContent":"aC-z","header":"bC-z","close":"cC-z"};